/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable max-len */
// import { useEffectOnce } from '@hooks';
import qs from 'query-string';
import { PREFILLED_SHOP_DOMAIN_KEY } from '@constants';
// import { useEffect } from 'react';
import classes from './index.module.css';
import Connection from './Connection';
import ProductGallery from './ProductGallery';
import ProductInvolved from './ProductInvolved';

export default function Home() {
  const parsed = qs.parse(window.location.search);
  const { shop, inst } = parsed;

  if ((inst === '0' || inst === 'fail') && shop) {
    localStorage.setItem(PREFILLED_SHOP_DOMAIN_KEY, shop);
  }

  // useEffect(() => {
  //   console.log(process.env.BROADCART_CHANNEL_NAME);
  //   const channel = new BroadcastChannel(process.env.BROADCART_CHANNEL_NAME);
  //   channel.onmessage = (ev) => {
  //     console.log(ev.data);
  //     if (ev.data === 'Authentication Complete') {
  //       window.location.reload();
  //     } else if (ev.data === 'shout') {
  //       console.log('echo');
  //       channel.postMessage('echo');
  //     }
  //   };
  // }, []);

  return (
    <div className={classes.container}>
      {/* 主模块 */}
      <div className={classes.main}>
        <div className={classes.greeting}>
          <div className={classes.hi}>Hi there!</div>
          <div className={classes.welcome}>Welcome to Seel - the trust layer for your commerce. Start from here. Find the simplest way to offer best-in-class post-purchase guarantees.</div>
        </div>
        <div style={{ width: 20, height: 20 }} />
        <Connection />
      </div>
      <div style={{ width: 30, height: 30 }} />
      {/* 产品模块标题 */}
      <div className={classes.content_title}>All Seel products</div>
      {/* 产品模块 */}
      <div className={classes.wrap}>
        <div className={classes.product_container}>
          <ProductGallery />
        </div>
        <ProductInvolved />
      </div>
    </div>
  );
}
